// React
import { useEffect, useState } from 'react';

// React Router
import { useHistory } from 'react-router-dom';

// React Bootstrap
import { Card } from 'react-bootstrap';

// Third-party libraries
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

// Hooks
import { useApp } from '@react';

// Components
import { Icon, Text } from '@components';

// Services
import { Api, favoriteService } from '@services';

// Utils
import { isAdmin, isSuperAdmin, isSystemAdmin } from '@utils';

// Store
import { useMapStore } from '../../MapStore/UseMapStore';

export function MapEditTitle() {
  const mapID = useMapStore((state) => state.mapID);
  const mapName = useMapStore((state) => state.mapName);
  const selected = useMapStore((state) => state.selected);
  const saveMap = useMapStore((state) => state.saveMap);
  const setMapName = useMapStore((state) => state.setMapName);
  const setIsDirty = useMapStore((state) => state.setIsDirty);
  const isHydrating = useMapStore((state) => state.isHydrating);
  const [isFavorite, setIsFavorite] = useState<boolean>(false);
  const [loadingText, setLoadingText] = useState<string>('Loading');
  const app = useApp();
  const history = useHistory();
  const MySwal = withReactContent(Swal);
  const authorized = isAdmin() || isSystemAdmin() || isSuperAdmin();

  useEffect(() => {
    checkIsFavorite(app, mapID);
  }, []);

  useEffect(() => {
    if (!isHydrating) {
      setLoadingText('Loading');
      return;
    }

    const interval = setInterval(() => {
      setLoadingText((prev) => {
        if (prev === 'Loading...') return 'Loading';
        return prev + '.';
      });
    }, 400);

    return () => clearInterval(interval);
  }, [isHydrating]);

  const checkIsFavorite = async (app, id) => {
    const { data } = await favoriteService.getFavorites(app.id);
    const isFavorite = data.find((fav) => fav.itemType === 'Map' && fav.itemId.toString() === id);
    isFavorite ? setIsFavorite(true) : setIsFavorite(false);
  };

  const favoriteMap = async () => {
    setIsFavorite(true);
    return Api.post(`/maps/${mapID}/favorites`);
  };

  const unfavoriteMap = async () => {
    setIsFavorite(false);
    return Api.delete(`/maps/${mapID}/favorites`);
  };

  return (
    <div className="title-bar">
      <Card.Header>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div className="d-flex flex-row justify-content-start align-items-center">
            <Icon
              name={isFavorite ? 'star-fill' : 'star-empty'}
              variant="light"
              size="md"
              className="align-sub primary-icon"
              disabled={false}
              showPointer={true}
              onClick={isFavorite ? unfavoriteMap : favoriteMap}
            />
            {selected === 'overlay' ? (
              <Text className="fw-semibold fs-1x">
                <input
                  className="fw-semibold"
                  id="mapName"
                  type="text"
                  name="map-name"
                  value={mapName}
                  onChange={(e) => {
                    setMapName(e.target.value);
                  }}
                />
              </Text>
            ) : (
              <Text className="fw-semibold fs-1x ms-1">{mapName}</Text>
            )}
          </div>
          <div className="d-flex flex-row justify-content-end align-items-center">
            {authorized && (
              <div className="d-flex flex-row align-items-center">
                
                {/* --- Animated Text or Save Button --- */}
                {isHydrating ? (
                  <Text className="fw-semibold fs-md me-3 mb-0" style={{ width: '70px' }}>
                    {loadingText}
                  </Text>
                ) : (
                  <Icon
                    name={'floppy-disk'}
                    className="align-sub primary-icon"
                    variant="light"
                    disabled={false}
                    size="md"
                    showPointer={true}
                    onClick={() => {
                      MySwal.fire({
                        title: 'Are you sure you want to save your Map changes?',
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'Cancel',
                      }).then((submit) => {
                        if (submit.isConfirmed) {
                          setIsDirty(false);
                          saveMap();
                          history.push('/maps/' + mapID);
                        }
                      });
                    }}
                  />
                )}
                
                <Icon
                  name={'add'}
                  title={'Cancel Edit'}
                  className="sonarIcon-rotate-45 align-sub nav-text-icon"
                  disabled={false}
                  variant="light"
                  size="md"
                  showPointer={true}
                  onClick={() => {
                    history.push('/maps/' + mapID);
                  }}
                />
              </div>
            )}
          </div>
        </div>
      </Card.Header>
    </div>
  );
}